"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleRequestSort = exports.descendingComparator = exports.getComparator = exports.tableSort = void 0;
function tableSort(array, comparator) {
    var elementIndex2dArray = array.map(function (el, index) { return [el, index]; });
    elementIndex2dArray.sort(function (a, b) {
        var order = comparator(a[0], b[0]);
        if (order !== 0)
            return order;
        return a[1] - b[1];
    });
    return elementIndex2dArray.map(function (el) { return el[0]; });
}
exports.tableSort = tableSort;
function getComparator(order, orderBy) {
    return order === 'desc'
        ? function (a, b) { return descendingComparator(a, b, orderBy); }
        : function (a, b) { return -descendingComparator(a, b, orderBy); };
}
exports.getComparator = getComparator;
function descendingComparator(a, b, orderBy) {
    var orderBySafe = orderBy;
    if (b[orderBySafe] < a[orderBySafe]) {
        return -1;
    }
    if (b[orderBySafe] > a[orderBySafe]) {
        return 1;
    }
    return 0;
}
exports.descendingComparator = descendingComparator;
var handleRequestSort = function (event, property, order, setOrder, orderBy, setOrderBy) {
    var isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
};
exports.handleRequestSort = handleRequestSort;
//# sourceMappingURL=sortHelpers.js.map